import { Selectable } from '@hakimo-ui/shared/ui-base';
import { DataVersionOverride } from './data-version';
import { Permission } from './permissions';

export interface UserDTO {
  items: User[];
  total: number;
}
export interface AddUserPayload {
  name: string;
  email: string;
  employee_id?: string;
  roles: string[];
  password?: string;
  tenant_id: string;
  msp_tenants?: string;
  vision_tenants?: string;
}
export interface ModifyUserPayload {
  name?: string;
  employee_id?: string;
  roles?: string[];
  tenant_id?: string;
  msp_tenants?: string;
}

export type ModifyUserMspTenantsAction = 'assign' | 'remove';

export interface ModifyUserMspTenantsPayload {
  users: string[];
  mspTenants: string[];
  action: ModifyUserMspTenantsAction;
}

export interface ModifyUserMspLocationsPayload {
  users: string[];
  mspLocations: number[];
}

export interface ModifyUserAlarmTypeGroupsPayload {
  operation: 'add' | 'remove';
  alarmtype_group_ids: string[];
  target_user_id: string;
}

export interface DeleteUserPayload {
  enabled?: boolean;
}

export type Role =
  | 'Hakimo Support'
  | 'Demo Support'
  | 'MSP Operator'
  | 'MSP Manager'
  | 'GSOC Manager'; // add as needed

export interface MspTenant extends Selectable {
  // Which backend data version this tenant reads from ("v2" legacy tables,
  // "v3" unified tables). Only "v3" puts the X-Data-Version header on raw
  // alarm reads scoped to this tenant; "v2" is the legacy default and sends
  // nothing, so those reads stay byte-identical to pre-unification ones.
  version?: DataVersionOverride;
}

export interface User {
  name?: string | null;
  email: string;
  employeeId?: string | null;
  roles: Role[];
  id: string;
  userIntercomHash: string;
  permissions: Permission[];
  tenant: Selectable;
  mspTenants: MspTenant[] | null;
  mspLocations: Selectable[] | null;
  visionTenants: Selectable[] | null;
  enabled: boolean;
  alarm_types?: Array<{ id: string; type: string }>;
  alarmtype_groups?: Selectable[] | null;
  default_alarm_status_list?: string[];
  idleTimeoutMinutes?: number;
}

export interface UpdateSelfPayload {
  name?: string;
}

export interface UserEnabledFilter {
  showEnabled: boolean;
  showNotEnabled: boolean;
}

export interface UserListFilters {
  names: string[];
  emails: string[];
  employeeIds: string[];
  roles: string[];
  tenantIds: string[];
  enabled: UserEnabledFilter;
}

export type UserRole = string;

export enum SystemNotificationPreference {
  OFF = 'off',
  INACTIVE = 'inactive',
  ALWAYS = 'always',
}
